import { useState } from "react";

const CommodityReadOnlyRow = ({ index, t, commodityListItem, handleDeleteClick, handleEditClick, oddIdx, add, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	const onEdit = (event, commodityListItem) => {
		setError("");
		handleEditClick(event, commodityListItem, submitComplete);
	}

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, commodityListItem) {
		setError("");
		handleDeleteClick(event, commodityListItem, submitComplete);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{commodityListItem.productGroupName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{commodityListItem.commodityName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{commodityListItem.description}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{commodityListItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block me-4"}
					onClick={(event) => onEdit(event, commodityListItem)}>{t("page.edit")}</button>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, commodityListItem)}>
					{commodityListItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default CommodityReadOnlyRow;